import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {CommentListResultVo} from '../../common/shared/api/nicolas/vo/comment/CommentListResultVo.interface';
import {trimUndefinedFromObject} from '../../common/util/trimUndefinedFromObject';
import type {CommentListInput} from '../../graphql/generated/types';

/**
 * 댓글 목록 조회
 *
 * Origin: pageNicolasApi.getCommentList
 * API: POST /api/v8/store/community/list/comment
 */
export async function postStoreCommunityListComment(
  commentListInput: CommentListInput,
  options?: FetcherOptions
): Promise<ApiResultVo & CommentListResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v8/store/community/list/comment',
    {
      method: 'POST',
      data: trimUndefinedFromObject({
        seriesid: commentListInput.seriesId,
        singleid: commentListInput.productId,
        parentuid: commentListInput.parentUid,
        last_comment_uid: commentListInput.lastCommentUid,
        last_like_count: commentListInput.lastLikeCount,
        last_created_dt: commentListInput.lastCreatedDt,
        orderby: commentListInput.orderBy,
        page: commentListInput.page,
        size: commentListInput.size,
        sort_opt: commentListInput.sortType,
      }),
    },
    options
  );
  return response.data;
}
